import gql from 'graphql-tag';

export const blogPostFragment = gql`
  fragment blogPostFragment on BlogPost {
    dokkioClass
    id
    createdAt
    title
    excerpt
    url
  }
`;
export default blogPostFragment;
